export const useResolveApiUrl = () => {
  const config = useRuntimeConfig()

  return (relativePath: string) => {
    if (relativePath.startsWith('/v1.0')) {
      return config.public.NUXT_API_HOSTNAME + relativePath.replace('/v1.0', '')
    }

    return relativePath
  }
}
